/**
 * The original variable names are shown in the comments.
 * https://github.com/chanmratekoko/mmcalendar/blob/master/src/main/java/mmcalendar/Constants.java
 */

/**
 * SY
 * solar year (365.2587565) (1577917828 / 4320000.0)
 */
export const SOLAR_YEAR = 365.2587564814815;

/**
 * LM
 * lunar month (29.53058795) (1577917828 / 53433336.0)
 */

export const LUNAR_MONTH = 29.53058794607172;

/**
 * MO
 * beginning of 0 ME
 * Starting year of Myanmar era (year 0)
 */
export const MYANMAR_ERA_START = 1954168.050623;

/**
 * SE3
 * beginning of 3rd era
 */
export const THIRD_ERA_START = 1312;

/**
 * BY
 * Beginning of English Calendar
 */
export const ENGLISH_CAL_START = 640;

/**
 * EY
 * End of English Calendar
 */
export const ENGLISH_CAL_END = 2140;

/**
 * MBY
 * Beginning of Myanmar Calendar
 */
export const MYANMAR_CAL_START = 2;

/**
 * MEY
 * End of Myanmar Calendar
 */
export const MYANMAR_CAL_END = 1500;

/**
 * LT
 * Minimum accurate English year
 */
export const MINIMUM_ACCURATE_ENGLISH_YEAR = 1700;

/**
 * UT
 * Maximum accurate English year
 */
export const MAXIMUM_ACCURATE_ENGLISH_YEAR = 2018;

/**
 * MLT
 * Minimum accurate Myanmar year
 */
export const MINIMUM_ACCURATE_MYANMAR_YEAR = 1062;

/**
 * MUT
 * Maximum accurate Myanmar year
 */
export const MAXIMUM_ACCURATE_MYANMAR_YEAR = 1379;

/**
 * SG
 * Gregorian start in English calendar (1752/Sep/14)
 */
export const GREGORIAN_START_IN_ENGLISH_CAL = 2361222;

/**
 * EMA
 * Myanmar month names
 */
export const MYANMAR_MONTHS: string[] = [
  "First Waso",
  "Tagu",
  "Kason",
  "Nayon",
  "Waso",
  "Wagaung",
  "Tawthalin",
  "Thadingyut",
  "Tazaungmon",
  "Nadaw",
  "Pyatho",
  "Tabodwe",
  "Tabaung",
  "Late Tagu",
  "Late Kason",
];

/**
 * MSA
 * New Moon means Dark moon
 */
export const MOON_PHASES: string[] = [
  "Waxing",
  "Full Moon",
  "Waning",
  "New Moon",
];

/**
 * WDA
 * Week Days
 */
export const WEEK_DAYS: string[] = [
  "Saturday",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];
